import { render } from "./config-inputs.vue?vue&type=template&id=09f0ecae&scoped=true"
import script from "./config-inputs.vue?vue&type=script&lang=js"
export * from "./config-inputs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-09f0ecae"

export default script